<div class="relative overflow-hidden bg-black md:mt-12">
    <div
        class="absolute top-0 z-10 h-128 w-full bg-gradient-to-b from-white"></div>
    <div class="absolute z-0 w-full">
        <app-lazy-picture
            [lazy]="true"
            [configurations]="featuredImageConfiguration">
        </app-lazy-picture>
        <div
            class="bottom-gradient absolute bottom-0 z-0 h-40 w-full md:h-128"></div>
    </div>
    <div class="relative z-10 w-full">
        @if (faqs?.length) {
            <app-faq-contentful-section
                [faqs]="faqs"></app-faq-contentful-section>
        }
        <app-newsletter class="relative z-10"></app-newsletter>
        <div
            class="bottom-gradient absolute bottom-0 z-0 h-40 w-full md:h-128"></div>
    </div>
</div>
